// PAGE STATUS TYPES

export enum PageStatusEnum {
  LOADING = 'loading',
  DEFAULT = 'default',
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
}
export type PageStatus = PageStatusEnum | string;

// PAYMENT METHOD TYPES

export enum PaymentMethodEnum {
  PIX = 'PIX',
  APPLE_PAY = 'APPLE_PAY',
}
export type PaymentMethod = PaymentMethodEnum | string;

// Timeout to consider a screen view event tracking
export const SCREEN_VIEW_TIMEOUT_IN_MS = 5000; // 5 SECONDS

/**
 * Event tracking types for the checkout home page
 *
 * Stored on the DB "yooga_marketing"
 *
 * @link https://docs.google.com/spreadsheets/d/1fcyNcBBBLOMDOjobCFmvtJBfbuo5qFTlIS5ZPnTGFZ8/edit?gid=671104071#gid=671104071
 */
export enum EventTrackingEnum {

  // --------------------------------
  // PAGE EVENTS
  // --------------------------------

  // HOME
  CHECKOUT_HOME_VIEWED_PAGE = 'checkout-home-viewed-page',
  CHECKOUT_HOME_CLICKED_STORE_MENU = 'checkout-home-clicked-store-menu',
  CHECKOUT_HOME_CLICKED_ORDER_SUMMARY = 'checkout-home-clicked-order-summary',
  CHECKOUT_HOME_CLICKED_PAYMENTS = 'checkout-home-clicked-payments',
  CHECKOUT_HOME_CLICKED_RECEIPTS = 'checkout-home-clicked-receipts',
  CHECKOUT_HOME_CLICKED_INSTAGRAM = 'checkout-home-clicked-instagram',

  // STORE MENU
  CHECKOUT_MENU_VIEWED_PAGE = 'checkout-menu-viewed-page',

  // CART
  CHECKOUT_CART_VIEWED_PAGE = 'checkout-cart-viewed-page',
  CHECKOUT_CART_CLICKED_CLEAR = 'checkout-cart-clicked-clear',
  CHECKOUT_CART_CLICKED_ADD_PRODUCT = 'checkout-cart-clicked-add-product',
  CHECKOUT_CART_CLICKED_CREATE_ORDER = 'checkout-cart-clicked-create-order',
  CHECKOUT_CART_CLICKED_ORDER_SENT = 'checkout-cart-clicked-order-sent',

  // ORDER SUMMARY
  CHECKOUT_ORDER_SUMMARY_VIEWED_PAGE = 'checkout-order-summary-viewed-page',
  CHECKOUT_ORDER_SUMMARY_CLICKED_CALL_WAITER = 'checkout-order-summary-clicked-call-waiter',
  CHECKOUT_ORDER_SUMMARY_CLICKED_ADD_PAYMENT = 'checkout-order-summary-clicked-add-payment',

  // --------------------------------
  // MODAL EVENTS
  // --------------------------------

  // AUTH
}
export type EventTracking = EventTrackingEnum | string;
